var gift_card_gateway = 'https://integrations.acquisitions.co.nz';
var current_gift_card = '';

function resetGiftCardFields(remove_message) {
  $('#gc_details').addClass('hide');
  $('#gc_balance_use').val('');
  $('#gc_balance_before').html('');
  $('#gc_balance_after').html('');

  if (remove_message) {
      resetGiftCardMessage();
  }

  $('input[name="_cart"]').val('');
  $('input[name="_gift_card_number"]').val('');
  $('input[name="_gift_card_balance_to_use"]').val('');

  $('.acquisitions-form').attr('action', '/cart');
}

function setGiftCardMessage(message, type) {
    $('#gc_success').addClass('hide');
    $('#gc_message')
        .html(message)
        .removeClass('hide error loading success')
        .addClass(type);
}

function resetGiftCardMessage() {
    $('#gc_success').addClass('hide');
    $('#gc_message')
        .html('')
        .removeClass('error loading success')
        .addClass('hide');
}

function disableButtons() {
    $('#acquisitions-cart-submit').attr('disabled', true).addClass('disabled');
    $('#gc_add').attr('disabled', true).addClass('disabled');
}

function enableButtons() {
    $('#acquisitions-cart-submit').attr('disabled', false).removeClass('disabled');
    $('#gc_add').attr('disabled', false).removeClass('disabled');
}

$(function () {
  var params = (new URL(document.location)).searchParams;
  var gc_param = params.get("gc");

  //Remove the parameter from the history
  if (gc_param !== null) {
    history.replaceState(null, null, "/cart")
  }
  if (gc_param === "s") {
    $('#acquisitions-cart-form').attr('action', '/cart');
    //todo: empty all gift card values
    $('#acquisitions-cart-submit').trigger('click');
  }

  $('#acquisitions-cart-submit').on('click', function (e) {
    console.log('gift');
    var gc_number = $('input[name="_gift_card_number"]').val();
    var gc_balance_use = $('input[name="_gift_card_balance_to_use"]').val();
    if (gc_number !== "" && gc_balance_use !== "") {
      e.preventDefault();
      $.ajax({
        type: 'GET',
        url: '/cart.json',
        dataType: 'json',
        success: function (data) {
          $('input[name="_cart"]').val(JSON.stringify(data));
          $('#acquisitions-cart-form').submit();
        },
        error: function () {
          $('#acquisitions-cart-form').submit();
        }
      });
    }
  });

  $('#gc_add').on('click', function(e){
     e.preventDefault();
      var value = $.trim($('#gc_number').val());
      var regex = new RegExp('^[0-9]{16}$', 'g');

      if (regex.test(value) !== true) {
          console.log('number invalid');
          resetGiftCardFields(false);
          setGiftCardMessage('Invalid gift card number', 'error');
          return false;
      }

      $.ajax({
          url: gift_card_gateway + '/verify-gift-card',
          type: 'POST',
          data: {
              '_gift_card_number': value
          },
          beforeSend: function() {
              console.log('ajax beforeSend');
              setGiftCardMessage('Checking gift card...', 'loading');
              disableButtons();
          },
          success: function (card) {
              console.log('ajax success');
              if (card.valid) {
                  if (card.balance > 0) {
                      var cart_total = $('#CartSubtotal').text();
                      cart_total = parseFloat(cart_total.replace('$', ''));
                    console.log(cart_total);
                    console.log(card.balance);
                      var to_use = card.balance >= cart_total ? cart_total : card.balance;
                    console.log(to_use);
                      var balance_after = card.balance - to_use;
                    console.log(balance_after);
                      $('.acquisitions-form').attr('action', gift_card_gateway + '/create-order');

                      setGiftCardMessage('Gift card number accepted', 'success');
                      $('#gc_success').html('$' + to_use + ' will be used from your gift card balance<br>Your balance will be $' + balance_after.toFixed(2) + ' after this purchase').removeClass('hide');
                      $('input[name="_gift_card_number"]').val(card.number);
                      $('input[name="_gift_card_balance_to_use"]').val(to_use);
                  } else {
                      setGiftCardMessage('Gift card has a balance of 0', 'error');
                      resetGiftCardFields(false);
                  }

              } else {
                  setGiftCardMessage('Invalid gift card number', 'error');
                  resetGiftCardFields(false);
              }
          },
          error: function () {
              console.log('ajax error');
              setGiftCardMessage('Invalid gift card number', 'error');
              resetGiftCardFields(false);
          },
          complete: function () {
              console.log('ajax complete');
              enableButtons();
          }
      });

  });

  $('#gc_balance_use').donetyping(function () {
    var value = $(this).val();
    var balance = parseFloat($('#gc_balance_before').text());
    if (value > balance) {
      $(this).val(balance).trigger('change');
      value = balance;
    }
    $('input[name="_gift_card_balance_to_use"]').val(value);
    var cart_total = $('#CartSubtotal').text();
    cart_total = parseFloat(cart_total.replace('$', ''));
    var balance_after = balance - value;
    $('#gc_balance_after').html(balance_after.toFixed(2));
  }, 300);

});
